<template>
    <div class="bento-container">
        <!-- Page Header -->
        <div class="bento-header">
            <div class="header-content">
                <div class="header-icon">
                    <i class="el-icon-user-solid"></i>
                </div>
                <div class="header-text">
                    <h2>用户群体</h2>
                    <p>课程管理 · 适用层级配置</p>
                </div>
            </div>
            <div class="header-actions">
                <div class="header-search">
                    <div class="search-input-wrapper">
                        <i class="el-icon-search input-icon"></i>
                        <el-input v-model="formDatas.acsuName" placeholder="搜索群体名称" clearable size="medium"
                            class="ai-input" @keyup.enter.native="partserch"></el-input>
                    </div>
                </div>
                <el-button class="ai-btn" @click="partserch">
                    <i class="el-icon-search"></i>
                    搜索
                </el-button>
                <el-button class="ai-btn secondary" @click="resetSearch">
                    <i class="el-icon-refresh"></i>
                    重置
                </el-button>
                <el-button class="ai-btn secondary" @click="addForm">
                    <i class="el-icon-plus"></i>
                    新增群体
                </el-button>
            </div>
        </div>

        <!-- Bento Grid Layout -->
        <div class="bento-grid">
            <div class="bento-card table-card full">
                <div class="card-header">
                    <span class="card-title">
                        <i class="el-icon-notebook-2"></i>
                        群体列表
                    </span>
                    <div class="card-actions">
                        <span class="ai-hint">
                            <i class="el-icon-info"></i>
                            用户群体管理
                        </span>
                    </div>
                </div>
                <div class="card-content">
                    <aj-table ref="ajTable" :data="tableData" :columns="tableColumns" :editable="tableEditable"
                        :use-internal-pagination="true" :currentPage.sync="formDatas.currentPage" :height="tableHeight"
                        :pageSize.sync="formDatas.pageSize" :total="totalCount" row-id-key="acsuId" stripe
                        @page-change="handlePageChange" @operate-btn-click="handleOperateBtnClick"
                        @selection-change="handleSelectionChange">
                    </aj-table>
                </div>
            </div>
        </div>

        <!-- Dialogs -->
        <aj-form-add ref="add_user" :formConfig="formConfig" :formData="form" :dialogVisible="addDialogVisible"
            dialogTitle="新增用户群体" dialogWidth="600px" formSize="small" cancelText="关闭" confirmText="提交新增"
            @confirm="handleAddConfirm" @update:dialogVisible="val => addDialogVisible = val" labelWidth="100px"
            @item-change="handleItemChange">
        </aj-form-add>
        <aj-form-edit ref="edit_user" :formConfig="formConfig" :formData="form" :dialogVisible="editDialogVisible"
            @update:dialogVisible="val => editDialogVisible = val" dialogTitle="编辑用户群体" labelWidth="100px"
            @confirm="handleEditConfirm" dialogWidth="600px">
        </aj-form-edit>
    </div>
</template>

<script>
import {
    getAjCourseSuitableUserList,
    addAjCourseSuitableUser,
    updateAjCourseSuitableUser,
    deleteAjCourseSuitableUser
} from "../../api/api";

export default {
    name: "courseSuitableUser",
    components: {},
    data() {
        return {
            tableHeight:null,
            addDialogVisible: false,
            editDialogVisible: false,
            form: {},
            formConfig: [],
            totalCount: 0,
            tableData: [],
            tableColumns: [
                { type: 'index', label: '序号', width: 80, fixed: 'left' },
                { label: '群体名称', prop: 'acsuName', align: 'center', fixed: 'left' },
                { label: '创建时间', prop: 'createtime', width: 180, align: 'center' },
                {
                    type: 'operation',
                    label: '操作',
                    prop: 'operation',
                    fixed: 'right',
                    width: 180,
                    buttons: [
                        { key: 'edit', text: '编辑', icon: 'el-icon-edit' },
                        { key: 'delete', text: '删除', icon: 'el-icon-delete' }
                    ]
                }
            ],
            tableEditable: false,

            formDatas: {
                acsuName: '',
                currentPage: 1,
                pageSize: 20,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.partserch();
    },
     mounted() {
        // 初始化表格高度
        this.handleResize()
        // 监听窗口大小变化
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
          handleResize() {
            this.$nextTick(() => {
                const cardContent = this.$el.querySelector('.card-content');
                this.tableHeight = this.$utils.getContainerAvailableHeight(cardContent, { extraOffset:100 });
            });
        },
        // 表单配置项
        getFormInit() {
            this.formConfig = [
                [{ type: 'input', label: '群体名称', prop: 'acsuName', placeholder: '请输入群体名称', span: 24, required: true }],
            ];
            this.form = {
                acsuName: '',
            };
        },
        // 编辑提交
        async handleEditConfirm({ data }) {
            console.log('编辑提交：', data);
            try {
                await this.$confirmDialog({
                    content: '确认编辑该群体吗？',
                    type: 'success'
                });
                const newData = JSON.parse(JSON.stringify(data));
                updateAjCourseSuitableUser(newData).then(res => {
                    if (res.status == 200) {
                        this.$message.success('编辑成功');
                        this.$refs.edit_user.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '编辑失败');
                    }
                });
            } catch {
                // this.$message.error('取消');
            }
        },
        // 表单项变更监听
        handleItemChange({ prop, value, type }) {
            console.log(`【${type}】${prop} 变更为：`, value);
        },
        // 新增提交
        async handleAddConfirm({ data }) {
            try {
                await this.$confirmDialog({
                    content: '确认新增该群体吗？',
                    type: 'success'
                });
                const newData = JSON.parse(JSON.stringify(data));
                addAjCourseSuitableUser(newData).then(res => {
                    if (res.status === 200) {
                        this.$message.success('新增成功');
                        this.$refs.add_user.cancelDiaLog();
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '新增失败');
                    }
                });
            } catch {
                // this.$message.error('取消');
            }
        },

        addForm() {
            this.getFormInit();
            this.addDialogVisible = true;
        },

        // 分页切换回调
        handlePageChange({ currentPage, pageSize }) {
            console.log('分页切换：', `第${currentPage}页，每页${pageSize}条`);
            this.formDatas.currentPage = currentPage;
            this.formDatas.pageSize = pageSize;
            this.getListData();
        },

        // 操作按钮点击回调
        handleOperateBtnClick({ btn, row }) {
            switch (btn.key) {
                case 'edit':
                    this.handleEdit(row);
                    break;
                case 'delete':
                    this.handleDelete(row);
                    break;
            }
        },
        // 选中状态变化回调
        handleSelectionChange(selRows) {
            console.log('当前页选中行：', selRows.map(row => row.id));
        },
        // 编辑操作
        handleEdit(row) {
            this.getFormInit();
            const s = JSON.parse(JSON.stringify(row));
            this.form = s;
            this.editDialogVisible = true;
        },
        // 删除操作
        async handleDelete(row) {
            try {
                await this.$confirmDialog({
                    content: '确认删除该群体吗？',
                    type: 'danger'
                });
                deleteAjCourseSuitableUser({ acsuId: row.acsuId }).then(res => {
                    if (res.status === 200) {
                        this.$message.success('删除成功');
                        this.partserch();
                    } else {
                        this.$message.error(res.msg || '删除失败');
                    }
                });
            } catch {
                // this.$message.error('取消');
            }
        },

        // 获取列表数据
        getListData() {
            getAjCourseSuitableUserList(this.formDatas).then((res) => {
                if (res.status === 200) {
                    this.tableData = res.data || [];
                    this.totalCount = res.total || 0;
                }
            });
        },

        partserch() {
            this.formDatas.currentPage = 1;
            this.getListData();
        },
        resetSearch() {
            this.formDatas.acsuName = '';
            this.partserch();
        },
    },
};
</script>

<style scoped>
/* Bento Grid Layout */
.bento-container {
    padding: 15px 20px;
    min-height: 100%;
}

/* Page Header */
.bento-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding: 20px 24px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
}

.header-content {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
    border-radius: 12px;
    color: white;
    font-size: 24px;
}

.header-text h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
}

.header-text p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #64748b;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-search {
    flex: 1;
    max-width: 280px;
}

/* AI Button Styles */
.ai-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
    color: white;
    box-shadow: 0 4px 14px rgba(34, 197, 94, 0.4);
}

.ai-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(34, 197, 94, 0.5);
}

.ai-btn.secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
    box-shadow: none;
}

.ai-btn.secondary:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
}

/* Bento Grid */
.bento-grid {
    grid-template-columns: 1fr;
    gap: 20px;
}

/* Bento Card */
.bento-card {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.bento-card.full {
    width: 100%;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f5f9;
}

.card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
}

.card-title i {
    color: #22c55e;
}

.ai-hint {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #94a3b8;
    padding: 4px 10px;
    background: #f0fdf4;
    border-radius: 20px;
}

/* Search Card */
.search-card {
    grid-column: span 1;
}

.search-row {
    display: flex;
    gap: 12px;
    align-items: center;
}

.search-input-wrapper {
    flex: 1;
    position: relative;
}

.input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    z-index: 1;
}

.ai-input ::v-deep .el-input__inner {
    padding-left: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    transition: all 0.3s;
}

.ai-input ::v-deep .el-input__inner:focus {
    border-color: #22c55e;
    background: white;
    box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);
}

/* Table Card */
.table-card {
    width: 100%;
    min-height: 400px;
}

.card-content {
    padding: 4px 0;
}

/* Scrollbar */
.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* Responsive */
@media (max-width: 768px) {
    .bento-header {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .header-actions {
        width: 100%;
        flex-wrap: wrap;
    }

    .header-search {
        max-width: 100%;
        flex: 1;
    }
}
</style>
